import { action } from 'typesafe-actions';
import {
  WORLD_CUP_MATCHES_REQUEST,
  WORLD_CUP_MATCHES_FAILURE,
  WORLD_CUP_MATCHES_SUCCESS,
} from '../../constants/worldCupMatches';

export const worldCupMatchesRequestAction = () =>
  action(WORLD_CUP_MATCHES_REQUEST);
export const worldCupMatchesSuccessAction = (data: any) =>
  action(WORLD_CUP_MATCHES_SUCCESS, data);
export const worldCupMatchesFailureAction = (e: any) =>
  action(WORLD_CUP_MATCHES_FAILURE, e);

export const worldCupMatchesActions = {
  worldCupMatchesRequestAction,
  worldCupMatchesSuccessAction,
  worldCupMatchesFailureAction,
};
